/* File: language.jsx
 * Path: ananunadm/src/helpers/language.jsx
*/
import { useContext, createContext } from "react";
import { Flex, Button } from "@mantine/core";

export const Language = createContext();

export function useLang() {
	return useContext(Language);
}

export function LanguagePicker({ data }) {
	const { lang, setLang } = useLang();
	return (
		<Flex wrap="wrap" mt={1} direction={"row"} gap={4}>
			{data.map((item) => (
				<Button
					key={item.value}
					justify="center"
					value={item.value}
					onClick={() => setLang(item.value)}
					m={2}
					leftSection={item.image}
					variant={lang === item.value ? "light" : "default"}
				>
					{item.label}
				</Button>
			))}
		</Flex>
	);
}
